import styled from "styled-components"
import { LoadingSpinner } from "ui/base/loading/LoadingSpinner"

// var(--page-height) — remaining space between header and footer (100dvh - header - footer)
export const PAGE_HEIGHT = "var(--page-height, calc(100dvh - var(--header-height, 0px) - var(--footer-height, 0px)))"

export const LoaderComponent = ({
  label = "Loading...",
  minHeight = "auto",
  textColor = "#1d1d1f",
  className,
}) => {
  return (
    <LoadingContainer
      className={className}
      minHeight={minHeight}>
      <LoadingSpinner variant='primary' />
      <Label textColor={textColor}>{label}</Label>
    </LoadingContainer>
  )
}

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ minHeight }) => minHeight};
  text-align: center;
  gap: 0.5rem;
`

const Label = styled.div`
  color: ${({ textColor }) => textColor};
`